<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <dl class="item">
          <a href="/dashboard">
            <button class="footerNavi-button button-secondary">
              ダッシュボードに戻る
            </button>
          </a>
        </dl>
        <h2 class="common-title">タイムライン作成</h2>
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <template v-else-if="isStaff">
          <dl class="item">
            運営アカウントはタイムライン作成できません
          </dl>
        </template>
        <template v-else>
          <div class="timeline-edit">
            <ul class="note">
              <li>タイムラインに項目を追加するには、<img src="./assets/add.png" class="icon12"> を押してください。</li>
              <li>項目は時系列（未来が上、過去が下）順に記載しましょう。<img src="./assets/up.png" class="icon12"> と <img src="./assets/down.png" class="icon12"> で時系列を変更できます。</li>
              <li>各項目を編集後、「確定」の後に「更新」を押すと保存できます。</li>
            </ul>
            <template v-if="isNew && cancerHistory">
              <div class="guide-module">
                <div class="guide-module-item">
                  <h4 class="module-title">プロフィールの「罹患歴」は、タイムライン機能にアップデートされました。<br>
                    「罹患歴」の内容を参考に、タイムラインを入力してください。<br>
                    <br>
                    なお、タイムラインを1度でも保存した場合、「罹患歴」は確認できなくなります。</h4>
                  <h4>保存されている「罹患歴」</h4>
                  <span>{{cancerHistory}}</span>
                </div>
                <a href="/counselingDetail" v-if="createButton"><button class="footerNavi-button button-primary">相談してみる</button></a>
              </div>
            </template>


            <div class="timeline-add">
              <a><img class="icon16" src="./assets/add.png"  v-on:click="add(0)"></a>
            </div>

            <div v-for="timelineContent in timelineContents" :key="timelineContent.id">
              <dl class="item timeline-item" v-bind:class='{entered:timelineContent.entered}'>
                <dt v-if="timelineContent.entered" class="term">{{timelineContent.selectedStartYear}}年{{timelineContent.selectedStartMonth}}月
                  <template v-if="!timelineContent.isStill"> - {{timelineContent.selectedEndYear}}年{{timelineContent.selectedEndMonth}}月</template>
                  <template v-if="timelineContent.isFuture">
                    <span class="futre">未来</span>
                  </template>
                  <template v-else-if="!timelineContent.isSpecialContent">
                    <template v-if="timelineContent.isStill">
                      <span class="still">現在継続中</span>
                    </template>
                  </template>
                </dt>
                <dt v-else class="term">
                  <input v-model="timelineContent.isStill" type="checkbox"><span class="still">現在継続中</span><br>
                  <select v-model="timelineContent.selectedStartYear">
                    <option disabled value="">-</option>
                    <option v-for="year in years" v-bind:value="year" :key="year">{{year}}</option>
                  </select>
                  <select v-model="timelineContent.selectedStartMonth">
                    <option disabled value="">-</option>
                    <option v-for="month in months" v-bind:value="month" :key="month">{{month}}</option>
                  </select>
                  <template v-if="!timelineContent.isStill">
                    -
                    <select v-model="timelineContent.selectedEndYear">
                      <option disabled value="">-</option>
                      <option v-for="year in years" v-bind:value="year" :key="year">{{year}}</option>
                    </select>
                    <select v-model="timelineContent.selectedEndMonth">
                      <option disabled value="">-</option>
                      <option v-for="month in months" v-bind:value="month" :key="month">{{month}}</option>
                    </select>
                  </template>
                </dt>

                <template v-if="timelineContent.entered">
                  <dd class="category1" v-if="timelineContent.selectedCategory1"><span class="category1-content">{{timelineContent.selectedCategory1}}</span></dd>
                  <dd class="category2" v-if="timelineContent.selectedCategory2"><span class="category2-content">{{timelineContent.selectedCategory2}}</span></dd>
                </template>
                <template v-else>
                  <dd class="profile-input category1">
                    <select v-model="timelineContent.selectedCategory1" v-on:change="fetchSubCategory(timelineContent.id)">
                      <option v-bind:value="category.name" v-for="category in categories" :key="category">{{category.name}}</option>
                    </select>
                  </dd>
                  <dd class="profile-input category2">
                    <select v-model="timelineContent.selectedCategory2">
                      <option v-bind:value="subCategory.name" v-for="subCategory in timelineContent.subCategories" :key="subCategory">{{subCategory.name}}</option>
                    </select>
                  </dd>
                </template>
                
                <dd v-if="timelineContent.entered" class="memo">{{timelineContent.memo}}</dd>
                <dd v-else class="profile-input"><textarea v-model="timelineContent.memo" placeholder="" maxlength="200"></textarea></dd><dd v-if="!timelineContent.isSpecialContent" class="profile-textSmall">{{timelineContent.memo.length}} / 200文字</dd>

                <div class="edit">
                  <template v-if="timelineContent.entered">
                    <a v-if="!timelineContent.isSpecialContent"><img class="icon16" src="./assets/edit.png" v-on:click="edit(timelineContent.id)"></a>
                    <a><img class="icon12" src="./assets/up.png" v-on:click="up(timelineContent.id)"></a><br>
                    <a><img class="icon12" src="./assets/down.png" v-on:click="down(timelineContent.id)"></a>
                  </template>
                  <template v-else>
                    <a v-if="!timelineContent.entered" class="submit" v-on:click="edit(timelineContent.id)">確定</a>
                  </template>
                </div>

                <div class="remove">
                  <a v-if="!timelineContent.entered" class="submit" v-on:click="remove(timelineContent.id)">削除</a>
                </div>
              </dl>
              <div class="timeline-add">
                <a><img class="icon16" src="./assets/add.png"  v-on:click="add(timelineContent.id)"></a>
              </div>
            </div>

            <div class="content-footerNavi">
              <template v-if="isNew">
                <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="createTimelineData()">
                  保存
                </button>
              </template>
              <template v-else>
                <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="updateTimelineData()">
                  更新
                </button>
              </template>
            </div>
          </div>
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, /*Storage,*/ graphqlOperation, Analytics, Logger } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { listUsersBySpecificUser } from './graphql/queries'
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { createErrorLog } from "./graphql/mutations"
import { listTimelinesBySpecificUser } from './graphql/queries'
import { createTimeline } from './graphql/mutations'
import { updateTimeline } from './graphql/mutations'
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('Timeline');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'timeline',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      isActiveButtonPrimary: true,
      isActiveButtonDisabled: false,
      isPostProcessing: false,
      contactUrl: '',
      isLoading: true,
      birthDate: null,
      diagnosedDate: null,
      timelineContents: [],
      isNew: false,
      cancerHistory: null,
      timelineId: null,
      years: [], // 誕生日によって動的に変更
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      categories: [
        /* TODO カテゴリ定義 */ 
        {id: 1, name: '治療'},
        {id: 2, name: '仕事'},
        {id: 3, name: '子ども・家族'},
        {id: 4, name: 'お金'},
        {id: 5, name: '生活'}
      ],
      subCategories1: [
        {id: 1, name: '治療全般'},
        {id: 2, name: '手術療法'},
        {id: 3, name: '放射線療法'},
        {id: 4, name: '化学療法（抗がん剤治療）'},
        {id: 5, name: 'ホルモン療法'},
        {id: 6, name: '分子標的薬'},
        {id: 7, name: '造血幹細胞移植'},
        {id: 8, name: '免疫療法'}
      ],
      subCategories2:  [
        {id: 1, name: '仕事全般'},
        {id: 2, name: '勤務'},
        {id: 3, name: '休職'},
        {id: 4, name: '就職活動・転職活動'}
      ],
      subCategories3: [
        {id: 1, name: '子ども・家族全般'},
        {id: 2, name: '不妊治療'},
        {id: 3, name: '妊娠'},
        {id: 4, name: '出産'},
        {id: 5, name: '介護・看護'}
      ],
      subCategories4: [
        {id: 1, name: 'お金全般'},
        {id: 2, name: '生命保険・医療保険'},
        {id: 3, name: '雇用保険'},
        {id: 4, name: '傷病手当金'},
        {id: 5, name: '障害認定'},
        {id: 6, name: '障害年金'}
      ],
      subCategories5: [
        {id: 1, name: '生活全般'},
        {id: 2, name: '転居'},
        {id: 3, name: '結婚'}
      ],
    }
  },

  created () {
    this.refresh()
  },

  methods: {
    // 新規作成保存時
    createTimelineData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // ソート順チェック (タイムライン要素が2個以上の場合チェック)
        if (this.timelineContents.length > 1) {
          for (let i = 1; i < this.timelineContents.length; i++) {
            if (!this.timelineContents[i - 1].entered) {
              alert('「確定」していない項目があります')
              this.isPostProcessing = false
              this.isActiveButtonPrimary = true
              this.isActiveButtonDisabled = false
              return
            }
            let beforeDate = new Date(this.timelineContents[i - 1].selectedStartYear, this.timelineContents[i - 1].selectedStartMonth - 1, 1, 0, 0, 0)
            let afterDate = new Date(this.timelineContents[i].selectedStartYear, this.timelineContents[i].selectedStartMonth - 1, 1, 0, 0, 0)
            if (beforeDate.getTime() < afterDate.getTime()) {
              alert('イベントが時系列順に並んでいない箇所があります')
              this.isPostProcessing = false
              this.isActiveButtonPrimary = true
              this.isActiveButtonDisabled = false
              return
            }
          }
        }
        
        const timelineData = {
          type: 'timeline',
          userid: this.id,
          userType: this.userType,
          timelineContents: JSON.stringify(this.timelineContents),
          addUser: 'system',
          createAt: new Date(),
          updateAt: new Date()
        }

        try {
          await API.graphql(graphqlOperation(
            createTimeline, { input: timelineData }
          ))
          alert("保存しました")
          this.$router.push({ path: '../profile/' + this.id })

        } catch (error) {
          //alert(JSON.stringify(userData))
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Timeline',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Timeline Create : createTimeline',
              errorNumber: 'Timeline-01',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Timeline',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Timeline Create : createTimeline',
            errorNumber: 'Timeline-01',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert('保存に失敗しました')
        }
      }
    },


    // 更新時
    updateTimelineData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // ソート順チェック (タイムライン要素が2個以上の場合チェック)
        if (this.timelineContents.length > 1) {
          for (let i = 1; i < this.timelineContents.length; i++) {
            if (!this.timelineContents[i - 1].entered) {
              alert('「確定」していない項目があります')
              this.isPostProcessing = false
              this.isActiveButtonPrimary = true
              this.isActiveButtonDisabled = false
              return
            }
            let beforeDate = new Date(this.timelineContents[i - 1].selectedStartYear, this.timelineContents[i - 1].selectedStartMonth - 1, 1, 0, 0, 0)
            let afterDate = new Date(this.timelineContents[i].selectedStartYear, this.timelineContents[i].selectedStartMonth - 1, 1, 0, 0, 0)
            if (beforeDate.getTime() < afterDate.getTime()) {
              alert('イベントが時系列順に並んでいない箇所があります')
              this.isPostProcessing = false
              this.isActiveButtonPrimary = true
              this.isActiveButtonDisabled = false
              return
            }
          }
        }

        const timelineData = {
          id: this.timelineId,
          type: 'timeline',
          userid: this.id,
          userType: this.userType,
          timelineContents: JSON.stringify(this.timelineContents),
          addUser: 'system',
          //createAt: new Date(),
          updateAt: new Date()
        }
        //alert(JSON.stringify(timelineData))

        try {
          await API.graphql(graphqlOperation(
            updateTimeline, { input: timelineData }
          ))
          alert("更新しました")
          this.$router.push({ path: '../profile/' + this.id })

        } catch (error) {
          //alert(JSON.stringify(error))
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Timeline',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Timeline Update : updateTimeline',
              errorNumber: 'Timeline-02',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Timeline',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Timeline Update : updateTimeline',
            errorNumber: 'Timeline-02',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert('保存に失敗しました')
        }
      }
    },

    // 編集・確定ボタン
    edit(id) {
      // 「確定」時に、年月のすべてが埋まっているかチェック、falseなら確定させない
      if (!this.timelineContents[id - 1].entered) {
        let isError = false
        let errorMsg = '\n'

        // StartYear
        if (!this.timelineContents[id - 1].selectedStartYear) {
          isError = true
          errorMsg += '\n開始年が未入力です'
        }

        // StartMonth
        if (!this.timelineContents[id - 1].selectedStartMonth) {
          isError = true
          errorMsg += '\n開始月が未入力です'
        }


        // (EndYear & EndMonth) or isStill (終了が不足)
        // isStillがtrueの場合はOK
        if (!this.timelineContents[id - 1].isStill) {
          // iStillがfalseなので終了年月が必須
          // EndYear
          if (!this.timelineContents[id - 1].selectedEndYear) {
            isError = true
            errorMsg += '\n終了年が未入力です'
          }

          // EndMonth
          if (!this.timelineContents[id - 1].selectedEndMonth) {
            isError = true
            errorMsg += '\n終了月が未入力です'
          }

          // StartとEndの前後関係の検証
          let startDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
          let endDate = new Date(this.timelineContents[id - 1].selectedEndYear, this.timelineContents[id - 1].selectedEndMonth - 1, 1, 0, 0, 0)
          if (startDate.getTime() > endDate.getTime()) {
            isError = true
            errorMsg += '\n開始年月と終了年月の前後関係が正しくありません'
          }
        }

        // category1
        if (!this.timelineContents[id - 1].selectedCategory1) {
          isError = true
          errorMsg += '\nカテゴリが未選択です'
        }

        // category2
        if (!this.timelineContents[id - 1].selectedCategory2) {
          isError = true
          errorMsg += '\nサブカテゴリが未選択です'
        }

        // memo（1文字以上、200文字以下）
        let memoLength = this.timelineContents[id - 1].memo.length
        if (memoLength > 200) {
          isError = true
          errorMsg += '\n説明文が200文字を超過しています'
        }

        /*
        // 開始年月の前後関係が崩れていないかチェック
        var isSortError = false
        var sortErrorMsg = ''
        // 開始年月が埋まっている場合にチェック
        if (this.timelineContents[id - 1].selectedStartYear && this.timelineContents[id - 1].selectedStartMonth) {
          if (this.timelineContents.length === 0) {
            // タイムライン要素が0個の場合：チェックなし
          } else if (this.timelineContents.length === 1) {
            // タイムライン要素が1個の場合：チェックなし
          } else if (this.timelineContents.length === 2) {
            // 開始年月が埋まっている場合にチェック開始          
            // タイムライン要素が2個の場合：前後該当する部分と比較
            if (id === 1) {
              // idが1（indexが0）の場合、後ろの要素と比較
              let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
              let afterDate = new Date(this.timelineContents[id].selectedStartYear, this.timelineContents[id].selectedStartMonth - 1, 1, 0, 0, 0)
              if (targetDate.getTime() < afterDate.getTime()) {
                sortErrorMsg += '\nイベントが時系列順に並んでいない箇所があります'
                isSortError = true
              }
            } else {
              // idが2（indexが1）の場合、前の要素と比較
              let beforeDate = new Date(this.timelineContents[id - 2].selectedStartYear, this.timelineContents[id - 2].selectedStartMonth - 1, 1, 0, 0, 0)
              let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
              if (beforeDate.getTime() < targetDate.getTime()) {
                sortErrorMsg += '\nイベントが時系列順に並んでいない箇所があります'
                isSortError = true
              }
            } 
          } else {
            // タイムライン要素が3個以上の場合：前後と比較

            if (id === 1) {
              // 先頭の場合
              // idが1（indexが0）の場合、後ろの要素と比較
              let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
              let afterDate = new Date(this.timelineContents[id].selectedStartYear, this.timelineContents[id].selectedStartMonth - 1, 1, 0, 0, 0)
              if (targetDate.getTime() < afterDate.getTime()) {
                sortErrorMsg += '\nイベントが時系列順に並ぶように開始年月を指定してください'
                isSortError = true
              }
            } else if (id === this.timelineContents.length) {
              // 末尾の場合
              // idが2（indexが1）の場合、前の要素と比較
              let beforeDate = new Date(this.timelineContents[id - 2].selectedStartYear, this.timelineContents[id - 2].selectedStartMonth - 1, 1, 0, 0, 0)
              let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
              if (beforeDate.getTime() < targetDate.getTime()) {
                sortErrorMsg += '\nイベントが時系列順に並ぶように開始年月を指定してください'
                isSortError = true
              }
            } else {
              let beforeDate = new Date(this.timelineContents[id - 2].selectedStartYear, this.timelineContents[id - 2].selectedStartMonth - 1, 1, 0, 0, 0)
              let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
              let afterDate = new Date(this.timelineContents[id].selectedStartYear, this.timelineContents[id].selectedStartMonth - 1, 1, 0, 0, 0)
              if (!(targetDate.getTime() <= afterDate.getTime() && beforeDate.getTime() >= targetDate.getTime())) {
                sortErrorMsg += '\nイベントが時系列順に並ぶように開始年月を指定してください'
                isSortError = true
              }
            }
          }
        }
        */

        if (isError) {
          alert('必須項目を入力してください' + errorMsg)
          return
        }
      }


      //alert('編集ボタン - ID: ' + id)
      this.timelineContents[id - 1].entered = !this.timelineContents[id - 1].entered

      // selectedにデータコピー
      this.timelineContents[id - 1].termStartYear = this.timelineContents[id - 1].selectedStartYear
      this.timelineContents[id - 1].termStartMonth = this.timelineContents[id - 1].selectedStartMonth
      this.timelineContents[id - 1].termEndYear = this.timelineContents[id - 1].selectedEndYear
      this.timelineContents[id - 1].termEndMonth = this.timelineContents[id - 1].selectedEndMonth

      // isStillならEndの日付を空に
      if (this.timelineContents[id - 1].isStill) {
        this.timelineContents[id - 1].selectedEndYear = null
        this.timelineContents[id - 1].selectedEndMonth = null
      }

      // futureかどうかチェックして「this.timelineContents[i].isFuture」を追加
      let nowDate = new Date()
      let targetDate = new Date(this.timelineContents[id - 1].selectedStartYear, this.timelineContents[id - 1].selectedStartMonth - 1, 1, 0, 0, 0)
      if (nowDate.getTime() < targetDate.getTime()) {
        this.timelineContents[id - 1].isFuture = true
      } else {
        this.timelineContents[id - 1].isFuture = false
      }

      //alert(JSON.stringify(this.timelineContents[id - 1]))
    },

    // 上移動ボタン
    up(id) {
      //alert('上移動ボタン - ID: ' + id)

      // 一番上の場合は動作させない
      if (id === 1) {
        return
      }

      this.timelineContents[id - 1].id = id - 1
      this.timelineContents[id - 2].id = id

      this.timelineContents.sort (function(a, b) {
        if (a.id < b.id) {
          return -1
        } else {
          return 1
        }
      })
    },

    // 下移動ボタン
    down(id) {
      //alert('下移動ボタン - ID: ' + id)

      // 一番下の場合は動作させない
      if (id === this.timelineContents.length) {
        return
      }

      this.timelineContents[id - 1].id = id + 1
      this.timelineContents[id].id = id

      this.timelineContents.sort (function(a, b) {
        if (a.id < b.id) {
          return -1
        } else {
          return 1
        }
      })
    },

    // 追加ボタン
    add(id) {
      //alert('追加ボタン - ID: ' + id)
      var tmpTimelineContent = {id: id + 1, 
                                termStartYear: null, 
                                termStartMonth: null,
                                termEndYear: null,
                                termEndMonth: null,
                                isStill: false,
                                selectedCategory1: null,
                                selectedCategory2: null,
                                memo: '',
                                entered: true}
      this.timelineContents.splice(id, 0, tmpTimelineContent)

      // addで追加時のデフォルトの年選択
      if (this.timelineContents.length > 1) {
        if (id === 0) {
          // 先頭の場合、1つ後ろの値と同値
          this.timelineContents[id].selectedStartYear = this.timelineContents[id + 1].selectedStartYear
          this.timelineContents[id].selectedEndYear = this.timelineContents[id + 1].selectedStartYear
        } else if (id === this.timelineContents.length - 1) {
          // 末尾の場合、1つ前の値と同値
          this.timelineContents[id].selectedStartYear = this.timelineContents[id - 1].selectedStartYear
          this.timelineContents[id].selectedEndYear = this.timelineContents[id - 1].selectedStartYear
        } else {
          // それ以外（中間の要素）は1つ前の値と同値
          this.timelineContents[id].selectedStartYear = this.timelineContents[id - 1].selectedStartYear
          this.timelineContents[id].selectedEndYear = this.timelineContents[id - 1].selectedStartYear
        }

      } else {
        // 追加した要素のみの場合は現在の年をデフォルト選択
        this.timelineContents[id].selectedStartYear = new Date().getFullYear()
        this.timelineContents[id].selectedEndYear = new Date().getFullYear()
      }
      

      // 既存要素のIDを修正
      for (let i = 0; i < this.timelineContents.length; i++) {
        // 追加したID以降のIDをずらす
        if (id < i) {
          this.timelineContents[i].id = i + 1
        }
      }

      // 追加した項目を編集モードに切り替え
      this.edit(id + 1)
    },

    // 削除ボタン
    remove(id) {
      //alert('削除ボタン - ID: ' + id)
      this.timelineContents.splice(id - 1, 1)

      // 既存要素のIDを修正
      for (let i = 0; i < this.timelineContents.length; i++) {
        // 追加したID以降のIDをずらす
        if (id - 1 <= i) {
          this.timelineContents[i].id = i + 1
        }
      }
    },

    // カテゴリ選択
    fetchSubCategory(id) {
      var subCategories = []
      this.timelineContents[id - 1].selectedCategory2 = ''
      if (this.timelineContents[id - 1].selectedCategory1 == '治療') {
        this.timelineContents[id - 1].subCategories = this.subCategories1
      } else if (this.timelineContents[id - 1].selectedCategory1 == '仕事') {
        this.timelineContents[id - 1].subCategories = this.subCategories2
      } else if (this.timelineContents[id - 1].selectedCategory1 == '子ども・家族') {
        this.timelineContents[id - 1].subCategories = this.subCategories3
      } else if (this.timelineContents[id - 1].selectedCategory1 == 'お金') {
        this.timelineContents[id - 1].subCategories = this.subCategories4
      } else if (this.timelineContents[id - 1].selectedCategory1 == '生活') {
        this.timelineContents[id - 1].subCategories = this.subCategories5
      }

      this.subCategories = subCategories
    },
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(
        graphqlOperation(listUsersBySpecificUser, {
          mailAddress: this.mailaddress,
          limit: 1
        })
      )
      this.birthDate = userData.data.listUsersBySpecificUser.items[0].birthDate
      this.diagnosedDate = userData.data.listUsersBySpecificUser.items[0].diagnosedDate
      this.cancerHistory = userData.data.listUsersBySpecificUser.items[0].cancerHistory

      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
        this.userType = 'user'
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
      this.isLoading = false
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
          this.isLoading = false
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
          this.isLoading = false
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.isLoading = false
      }
    }

    // プロフィール設定がまだの場合はDashboardに戻す
    if (!this.hasUserData) {
      this.$router.push({ path: '../dashboard' })
    }

    // タイムラインデータを取得
    try {
      let timelineData = await API.graphql(graphqlOperation(
        listTimelinesBySpecificUser, {userid: this.id, limit: 1}
      ))

      this.timelineContents = JSON.parse(timelineData.data.listTimelinesBySpecificUser.items[0].timelineContents)
      this.isNew = false
      this.timelineId = timelineData.data.listTimelinesBySpecificUser.items[0].id
    } catch (err) {
      // 誕生日の年月取得
      var tmpBirth = this.birthDate.match(/^([0-9]{4})-([0-9]{2})/)
      var birthYear = tmpBirth[1]
      var birthMonth = tmpBirth[2].replace(/^0+/, '')

      // 罹患発覚日の年月取得
      if (this.diagnosedDate) {
        var tmpDiagnosed = this.diagnosedDate.match(/^([0-9]{4})-([0-9]{2})/)
        var diagnosedYear = tmpDiagnosed[1]
        var diagnosedMonth = tmpDiagnosed[2].replace(/^0+/, '')

        this.timelineContents = [{id: 1, 
                                  termStartYear: diagnosedYear, 
                                  termStartMonth: diagnosedMonth,
                                  termEndYear: null, 
                                  termEndMonth: null,
                                  isStill: true,
                                  selectedCategory1: '治療',
                                  selectedCategory2: '罹患発覚日',
                                  memo: '',
                                  entered: true,
                                  isSpecialContent: true},
                                  {id: 2, 
                                  termStartYear: birthYear, 
                                  termStartMonth: birthMonth,
                                  termEndYear: null, 
                                  termEndMonth: null,
                                  isStill: true,
                                  selectedCategory1: '生活',
                                  selectedCategory2: '誕生日',
                                  memo: '',
                                  entered: true,
                                  isSpecialContent: true},
                                  ]
      } else {
        this.timelineContents = [{id: 1, 
                                  termStartYear: birthYear, 
                                  termStartMonth: birthMonth,
                                  termEndYear: null, 
                                  termEndMonth: null,
                                  isStill: true,
                                  selectedCategory1: '生活',
                                  selectedCategory2: '誕生日',
                                  memo: '',
                                  entered: true,
                                  isSpecialContent: true},
                                  ]
      }

      this.isNew = true
    }


    // 誕生日から年選択の開始年を取得（Startデフォ値）
    var optionYearStart = birthYear
    
    // 値が4桁でない場合は1900をセット
    if (String(optionYearStart).length != 4) {
      optionYearStart = 1900
    }

    // 130年後までを選択肢に追加（Endデフォ値）
    for (let i = 0; i < 130; i++) {
      this.years.push(Number(optionYearStart) + i)
    }

    // timelineContentsの中身をチェックし、必要な情報を追加
    for (let i = 0; i < this.timelineContents.length; i++) {
      this.timelineContents[i].selectedStartYear = this.timelineContents[i].termStartYear
      this.timelineContents[i].selectedStartMonth = this.timelineContents[i].termStartMonth
      this.timelineContents[i].selectedEndYear = this.timelineContents[i].termEndYear
      this.timelineContents[i].selectedEndMonth = this.timelineContents[i].termEndMonth

      // futureかどうかチェックして「this.timelineContents[i].isFuture」を追加
      let nowDate = new Date()
      let targetDate = new Date(this.timelineContents[i].selectedStartYear, this.timelineContents[i].selectedStartMonth - 1, 1, 0, 0, 0)
      if (nowDate.getTime() < targetDate.getTime()) {
        this.timelineContents[i].isFuture = true
      } else {
        this.timelineContents[i].isFuture = false
      }

      // category1の値に応じてcategory2の選択肢をセット
      if (this.timelineContents[i].selectedCategory1 == '治療') {
        this.timelineContents[i].subCategories = this.subCategories1
      } else if (this.timelineContents[i].selectedCategory1 == '仕事') {
        this.timelineContents[i].subCategories = this.subCategories2
      } else if (this.timelineContents[i].selectedCategory1 == '子ども・家族') {
        this.timelineContents[i].subCategories = this.subCategories3
      } else if (this.timelineContents[i].selectedCategory1 == 'お金') {
        this.timelineContents[i].subCategories = this.subCategories4
      } else if (this.timelineContents[i].selectedCategory1 == '生活') {
        this.timelineContents[i].subCategories = this.subCategories5
      }
    }



    this.isLoading = false

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Timeline',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/timeline',
          page_title: 'User:タイムライン編集 (/timeline)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/timeline',
          page_title: 'Adviser:タイムライン編集 (/timeline)'
        })
      }
    }
  }
}
</script>
<style>
</style>
<style src="./assets/style.css" />
